module.exports = __webpack_public_path__ + "img/outsourcing.85af410f.svg";